<template>
    <div>
        <div class="topRoot d-print-none">
            <div class="bar bg-dark">
                <b-container>
                    <b-row>
                        <b-col cols="2" class="d-lg-none pt-2">
                            <svgicon icon="menu" width="40" class="pointer" height="40" color="#fff" @click="$emit('toggleMobileMenu')"></svgicon>
                        </b-col>
                        <b-col cols="8" lg="3" class="text-center text-lg-left d-flex d-sm-block  align-items-center">
                            <router-link tag="a" to="/" >
                                <img src="/Dist/img/logo.png" class="logo" style="max-width:100%" />
                            </router-link>
                        </b-col>
                        <b-col cols="2" class="d-lg-none text-right pt-3">
                            <router-link tag="a" class="mobileBasketContainer" to="/basket" >
                                <svgicon icon="cart" width="30" height="30" color="#fff"></svgicon>
                                <div class="counter bg-secondary">{{basketCount}}</div>
                            </router-link>
                        </b-col>
                        <b-col class="text-right d-none d-lg-block">
                            <!-- <a class="text-left contact d-none d-lg-inline-block" href="tel:+4543328506">
                                <span class="icon d-inline-block"><svgicon icon="phone" width="34" height="34" :original="true"></svgicon></span>
                                <span class="text d-inline-block">
                                    <b>43 32 85 06</b><br>
                                    Brug for råd og vejledning?<br>
                                    Ring til os mellem 8.30-16.30
                                </span>
                            </a> -->
                            <!-- <router-link tag="a" class="iconContainer tilbud" to="/tilbud/ugens-tilbud" >
                                <svgicon icon="procent_tag" width="34" height="34" color="#fff"></svgicon>
                                <div class="iconText">Tilbud</div>
                            </router-link>
                            <router-link tag="a" class="iconContainer findbutik" to="/find-butik" >
                                <svgicon icon="map-marker-radius" width="34" height="34" color="#fff"></svgicon>
                                <div class="iconText">Find butik</div>
                            </router-link> -->
                            <!-- <router-link tag="a" class="iconContainer galleri" to="/valg-af-maling/">
                                <svgicon icon="ide" width="34" height="34" color="#fff"></svgicon>
                                <div class="iconText">Godt i gang</div>
                            </router-link>
                            <router-link tag="a" class="iconContainer galleri" to="/blog/">
                                <svgicon icon="image-multiple" width="34" height="34" color="#fff"></svgicon>
                                <div class="iconText">Blog</div>
                            </router-link>
                            <router-link tag="a" class="iconContainer udlejning" to="/vaerktoej/udlejning">
                                <svgicon icon="udlejning2" width="34" height="34" color="#fff"></svgicon>
                                <div class="iconText">Udlejning</div>
                            </router-link> -->
                            <router-link tag="a" class="iconContainer basket" to="/basket" >
                                <svgicon icon="cart" width="34" height="34" color="#fff"></svgicon>
                                <div class="iconText">Gå til kassen</div>
                                <div class="counter bg-secondary">{{basketCount}}</div>
                            </router-link>
                        </b-col> 
                    </b-row> 
                </b-container> 
            </div>
        </div>
    </div>
</template>
 
<script>
// import { mapGetters } from 'vuex';
// import "../../icons/_rk/procent";
import "../../icons/_rk/procent_tag";
import "../../icons/_rk/phone";
import "../../icons/phone-in-talk";
import "../../icons/map-marker-radius";
import "../../icons/image-multiple";
import "../../icons/cart";
import "../../icons/calendar-multiselect";
import "../../icons/_rk/ide";
import "../../icons/_rk/udlejning2";
import "../../icons/menu";

// import "../../icons/_rk/place-ikon";
// import "../../icons/_rk/Indkobsvogn-ikon";
// import "../../icons/_rk/Galleri-ikon";
import basketService from "../services/basketService.vue";

export default {
    computed:{
        basketCount(){
            var count = 0;
            for(var i=0;i<this.basket.length;i++)
                count += this.basket[i].Quantity;
            return count;
        },
        basket(){
            return basketService.basket;
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "~bootstrap/scss/_functions";
    @import "~bootstrap/scss/_variables";
    @import "~bootstrap/scss/_mixins";
    .udlejning /deep/ path[pid='2']{
        fill:black !important; 
    }
    .contact{
        margin-right:20px;
        font-size:13px;
        // display:block;
        color:white;
        @include media-breakpoint-only(xl){
            margin-right:100px;
        }
        > span{
            // vertical-align: middle;
        }
        .text{
            line-height:18px;
        }
        .icon{
            vertical-align: 30px;
            margin-right:10px;
            line-height:34px;
            width:36px;
            display:inline-block;
            text-align:center;

            /deep/ path[pid='1'],
            /deep/ path[pid='2']{
                display: none
            }
            
            border-radius: 50%;
            background-color:#2baf79;
        }
    }
    .topRoot{
        @include media-breakpoint-down(md){
            height:60px;
            // margin-top:76px;
            // margin-top:46px;
        }
        // @include media-breakpoint-up(md){
        //     // height:60px;
        //     // margin-top:76px;
        //     position:fixed;
        //     width:100%;
        //     z-index:10;
        // }
    }
    .bar{
        height: 62px;
        // background-color: #151515;
        color:white;
    }

    .logo{
        margin-left:-8px;
        margin-top: 11px;
    }
    .iconContainer
    {
        margin-top: 9px;
        display: inline-block;
        position: relative;
        text-align: center;
        // width: 80px;
        margin-left:20px;
        color:white;
        font-size:13px;
        .iconText{

        }
        img{
            height: 36px;
        }
        .counter{
            text-align:center;
            position:absolute;
            top:-7px;
            right: 10px;
            // width:100%;
            color:white;
            font-weight:bold;
            font-size:12px;
            padding: 1px 7px;
            // min-width: 18px;
            // background-color:$primary;
            border:solid 1px black;
            border-radius: 50%;
        }
    }


    @include media-breakpoint-down(md){
        .bar{
            height:auto;
            position: fixed;
            width:100%;
            z-index:100;
        }
        .logo{
            margin-top:0;
        }
        .mobileBasketContainer{
            display: inline-block;
            // position: relative;
            text-align: center;
            // width: 100px;
            color:white;
            .counter{
                text-align:center;
                position:absolute;
                top:3px;
                right: 3px;
                // width:100%;
                color:white;
                font-weight:bold;
                font-size:12px;
                padding: 1px 7px;
                // min-width: 18px;
                // background-color:$primary;
                border:solid 1px black;
                border-radius: 50%;
            }   
        }
    }
    
</style>
